import { useEffect, useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import {
  BlockServiceReasonAction,
  SalonAvailabilityDetailAction,
  SalonAvailabilityStaffUpdateAction,
  SalonAvailabilityUpdateAction,
} from "../../../../redux/Action/Availability";
import Button from "../../../../components/Ui/Button";
import Spinner from "../../../../components/Spinner";
import BlockService from "./BlockService";
import { FormattedMessage } from "react-intl";
import {
  extractTimeFromDate,
  LocalFormat,
  localFormToUtcDateAndTime,
  sidebarOpen,
  UTCFormat,
  utcStoredToLocalDateAndTime,
  WEEKDAY_UTC_ANCHOR,
} from "../../../../utils/Helper";

const timeToMinutes = (date: any) => {
  if (!date) return 0;
  const parsedDate = new Date(date);
  return parsedDate.getHours() * 60 + parsedDate.getMinutes();
};

const SalonAvailability = () => {
  const local_language = localStorage.getItem("lang");

  const dispatch = useDispatch<any>();
  const [calendarError, setCalendarError] = useState("");
  const salon_detail = useSelector(
    (state: any) => state.SalonAvailabilityState,
  );
  const profile_data = useSelector((state: any) => state.GetProfileState);
  const block_service_close_reason = useSelector(
    (state: any) => state.BlockServiceReasonState,
  );
  const block_service_data = useSelector(
    (state: any) => state.BlockServiceState,
  );
  const salon_availability_update = useSelector(
    (state: any) => state.SalonAvailabilityUpdateState,
  );

  const daysOfWeekAlbenia = {
    en: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    alb: [
      "E hënë",
      "E martë",
      "E mërkurë",
      "E enjte",
      "E premte",
      "E shtunë",
      "E diel",
    ],
  };
  const albanianToEnglishDaysMap: any = {
    "E hënë": "Monday",
    "E martë": "Tuesday",
    "E mërkurë": "Wednesday",
    "E enjte": "Thursday",
    "E premte": "Friday",
    "E shtunë": "Saturday",
    "E diel": "Sunday",
  };

  const [calendar, setCalendar] = useState([
    {
      day: daysOfWeekAlbenia.alb[0],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[1],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[2],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[3],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[4],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[5],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[6],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
  ]);

  // Handle checkbox change
  const handleCheckboxChange = (
    index: any,
    start: any,
    end: any,
    error: any,
  ) => {
    const updatedCalendar = [...calendar];
    updatedCalendar[index].is_day_off = !updatedCalendar[index].is_day_off;

    if (!updatedCalendar[index].is_day_off) {
      updatedCalendar[index].start_time = "";
      updatedCalendar[index].end_time = "";
      updatedCalendar[index].error = { start_time: "", end_time: "" };
    } else {
      if (!updatedCalendar[index].start_time) {
        updatedCalendar[index].error.start_time =
          local_language == "alb"
            ? "Ju lutemi shkruani orën e fillimit."
            : "Please enter start time";
      }
      if (!updatedCalendar[index].end_time) {
        updatedCalendar[index].error.end_time =
          local_language == "alb"
            ? "Ju lutemi shkruani orën e përfundimit"
            : "Please enter end time";
      }
    }

    setCalendar(updatedCalendar);
  };

  // Handle input field change
  // const handleInputFieldChange = (index: any, field: any, value: any) => {
  //   const updatedCalendar: any = [...calendar];
  //   updatedCalendar[index][field] = value;

  //   if (updatedCalendar[index].is_day_off) {
  //     if (field === "start_time" && value) {
  //       updatedCalendar[index].error.start_time = "";
  //     } else if (field === "end_time" && value) {
  //       updatedCalendar[index].error.end_time = "";
  //     }
  //   }

  //   if (!updatedCalendar[index].is_day_off) {
  //     if (
  //       (field === "start_time" && value) ||
  //       (field === "end_time" && value)
  //     ) {
  //       updatedCalendar[index].is_day_off = true;
  //     }
  //   }

  //   if (updatedCalendar[index].is_day_off) {
  //     if (field === "start_time" && !value) {
  //       updatedCalendar[index].error.start_time =
  //         local_language == "alb"
  //           ? "Ju lutemi shkruani orën e fillimit."
  //           : "Please enter start time";
  //     } else if (field === "end_time" && !value) {
  //       updatedCalendar[index].error.end_time =
  //         local_language == "alb"
  //           ? "Ju lutemi shkruani orën e përfundimit"
  //           : "Please enter end time";
  //     }
  //   }

  //   if (
  //     field === "start_time" &&
  //     updatedCalendar[index]["end_time"] &&
  //     value >= updatedCalendar[index]["end_time"]
  //   ) {
  //     updatedCalendar[index].error.start_time =
  //       local_language == "alb"
  //         ? "Koha e fillimit duhet të jetë më e hershme se koha e përfundimit"
  //         : "Start time must be earlier than end time";
  //   } else if (
  //     field === "end_time" &&
  //     updatedCalendar[index]["start_time"] &&
  //     value <= updatedCalendar[index]["start_time"]
  //   ) {
  //     updatedCalendar[index].error.end_time =
  //       local_language == "alb"
  //         ? "Koha e përfundimit duhet të jetë më vonë se ora e fillimit"
  //         : "End time must be later than start time";
  //   } else {
  //     updatedCalendar[index].error.start_time = "";
  //     updatedCalendar[index].error.end_time = "";
  //   }

  //   if (
  //     (field === "start_time" || field === "end_time") &&
  //     updatedCalendar[index]["start_time"] &&
  //     updatedCalendar[index]["end_time"]
  //   ) {
  //     const startTime = moment(updatedCalendar[index]["start_time"], "HH:mm");
  //     const endTime = moment(updatedCalendar[index]["end_time"], "HH:mm");

  //     if (!startTime.isValid()) {
  //       updatedCalendar[index].error.start_time = "Please select start time";
  //     } else if (!endTime.isValid()) {
  //       updatedCalendar[index].error.end_time = "Please select end time";
  //     } else {
  //       const duration = moment.duration(endTime.diff(startTime));
  //       if (duration.asHours() < 2) {
  //         updatedCalendar[index].error.end_time =
  //           local_language == "alb"
  //             ? "Duhet të ketë të paktën 2 orë ndërmjet kohës së fillimit dhe përfundimit"
  //             : "There must be at least 2 hours between start and end times";
  //       } else {
  //         updatedCalendar[index].error.end_time = "";
  //       }
  //     }
  //   }

  //   // Additional checks to ensure both times are provided
  //   if (field === "start_time" && !updatedCalendar[index]["end_time"]) {
  //     updatedCalendar[index].error.end_time =
  //       local_language == "alb"
  //         ? "Ju lutemi shkruani orën e përfundimit"
  //         : "Please enter end time";
  //   } else if (field === "end_time" && !updatedCalendar[index]["start_time"]) {
  //     updatedCalendar[index].error.start_time =
  //       local_language == "alb"
  //         ? "Ju lutemi shkruani orën e fillimit."
  //         : "Please enter start time";
  //   }

  //   setCalendar(updatedCalendar);
  // };

  const handleInputFieldChange = (index: any, field: any, value: any) => {
    const updatedCalendar: any = [...calendar];
    updatedCalendar[index][field] = value;

    if (!updatedCalendar[index].is_day_off && value) {
      updatedCalendar[index].is_day_off = true;
    }

    const start = updatedCalendar[index].start_time;
    const end = updatedCalendar[index].end_time;

    updatedCalendar[index].error = {
      start_time: "",
      end_time: "",
    };

    if (!start) {
      updatedCalendar[index].error.start_time =
        local_language == "alb"
          ? "Ju lutemi shkruani orën e fillimit."
          : "Please enter start time";
    }

    if (!end) {
      updatedCalendar[index].error.end_time =
        local_language == "alb"
          ? "Ju lutemi shkruani orën e përfundimit"
          : "Please enter end time";
    }

    if (start && end) {
      const startMinutes = timeToMinutes(start);
      const endMinutes = timeToMinutes(end);

      if (startMinutes >= endMinutes) {
        updatedCalendar[index].error.start_time =
          local_language == "alb"
            ? "Koha e fillimit duhet të jetë më e hershme se koha e përfundimit"
            : "Start time must be earlier than end time";

        updatedCalendar[index].error.end_time =
          local_language == "alb"
            ? "Koha e përfundimit duhet të jetë më vonë se ora e fillimit"
            : "End time must be later than start time";
      } else if (endMinutes - startMinutes < 120) {
        updatedCalendar[index].error.end_time =
          local_language == "alb"
            ? "Duhet të ketë të paktën 2 orë ndërmjet kohës së fillimit dhe përfundimit"
            : "There must be at least 2 hours between start and end times";
      }
    }

    setCalendar(updatedCalendar);
  };

  // const validateCalendar = () => {
  //   const updatedCalendar = [...calendar];
  //   let hasError = false;
  //   updatedCalendar.forEach((day, index) => {
  //     // Only validate when the day is selected (is_day_off is false)
  //     if (day?.is_day_off == true) {
  //       if (!day.start_time) {
  //         updatedCalendar[index].error.start_time =
  //           local_language == "alb"
  //             ? "Ju lutemi shkruani orën e fillimit."
  //             : "Please enter start time";
  //         hasError = true;
  //       }
  //       if (!day.end_time) {
  //         updatedCalendar[index].error.end_time =
  //           local_language == "alb"
  //             ? "Ju lutemi shkruani orën e përfundimit"
  //             : "Please enter end time";
  //         hasError = true;
  //       }

  //       if (day.start_time && day.end_time) {
  //         const startTime = moment(day.start_time, "HH:mm");
  //         const endTime = moment(day.end_time, "HH:mm");

  //         if (!startTime.isValid()) {
  //           updatedCalendar[index].error.start_time =
  //             "Please select start time";
  //           hasError = true;
  //         }
  //         if (!endTime.isValid()) {
  //           updatedCalendar[index].error.end_time = "Please select end time";
  //           hasError = true;
  //         }
  //         if (startTime.isValid() && endTime.isValid()) {
  //           const duration = moment.duration(endTime.diff(startTime));
  //           if (duration.asHours() < 2) {
  //             updatedCalendar[index].error.end_time =
  //               "There must be at least 2 hours between start and end times";
  //             hasError = true;
  //           }
  //         }
  //       }

  //       if (day.start_time && day.end_time && day.start_time >= day.end_time) {
  //         updatedCalendar[index].error.start_time =
  //           local_language == "alb"
  //             ? "Koha e fillimit duhet të jetë më e hershme se koha e përfundimit"
  //             : "Start time must be earlier than end time";
  //         hasError = true;
  //       }
  //       if (day.end_time && day.start_time && day.end_time <= day.start_time) {
  //         updatedCalendar[index].error.end_time =
  //           local_language == "alb"
  //             ? "Koha e përfundimit duhet të jetë më vonë se ora e fillimit"
  //             : "End time must be later than start time";
  //         hasError = true;
  //       }

  //       if (!day.start_time && day.end_time) {
  //         updatedCalendar[index].error.start_time =
  //           local_language == "alb"
  //             ? "Ju lutemi shkruani orën e fillimit."
  //             : "Please enter start time";
  //         hasError = true;
  //       }
  //       if (!day.end_time && day.start_time) {
  //         updatedCalendar[index].error.end_time =
  //           local_language == "alb"
  //             ? "Ju lutemi shkruani orën e përfundimit"
  //             : "Please enter end time";
  //         hasError = true;
  //       }
  //     }
  //   });

  //   setCalendar(updatedCalendar);
  //   return !hasError;
  // };

  const validateCalendar = () => {
    const updatedCalendar = [...calendar];
    let hasError = false;

    updatedCalendar.forEach((day, index) => {
      if (day.is_day_off) {
        updatedCalendar[index].error = {
          start_time: "",
          end_time: "",
        };

        if (!day.start_time) {
          updatedCalendar[index].error.start_time =
            local_language == "alb"
              ? "Ju lutemi shkruani orën e fillimit."
              : "Please enter start time";
          hasError = true;
        }

        if (!day.end_time) {
          updatedCalendar[index].error.end_time =
            local_language == "alb"
              ? "Ju lutemi shkruani orën e përfundimit"
              : "Please enter end time";
          hasError = true;
        }

        console.log({ startTime: day.start_time, endTime: day.end_time });

        if (day.start_time && day.end_time) {
          const startMinutes = timeToMinutes(day.start_time);
          const endMinutes = timeToMinutes(day.end_time);

          if (startMinutes >= endMinutes) {
            updatedCalendar[index].error.start_time =
              local_language == "alb"
                ? "Koha e fillimit duhet të jetë më e hershme se koha e përfundimit"
                : "Start time must be earlier than end time";

            updatedCalendar[index].error.end_time =
              local_language == "alb"
                ? "Koha e përfundimit duhet të jetë më vonë se ora e fillimit"
                : "End time must be later than start time";

            hasError = true;
          }

          if (endMinutes - startMinutes < 120) {
            updatedCalendar[index].error.end_time =
              local_language == "alb"
                ? "Duhet të ketë të paktën 2 orë ndërmjet kohës së fillimit dhe përfundimit"
                : "There must be at least 2 hours between start and end times";

            hasError = true;
          }
        }
      }
    });

    setCalendar(updatedCalendar);
    return !hasError;
  };

  const handleToClickAll = () => {
    const commonTime = calendar.find((day) => day.start_time && day.end_time);
    if (commonTime) {
      const { start_time, end_time } = commonTime;
      setCalendar(
        calendar.map((day) => ({
          ...day,
          start_time,
          end_time,
          is_day_off: true,
          error: { start_time: "", end_time: "" },
        })),
      );
    }
  };

  const [data, setData]: any = useState(null);

  useEffect(() => {
    const formatTimes = () => {
      const formattedCalendar: any = calendar.map((day) => {
        const englishDay = albanianToEnglishDaysMap[day.day];
        const anchor = englishDay ? WEEKDAY_UTC_ANCHOR[englishDay] : null;

        let start_time = "";
        let end_time = "";
        if (day.start_time && anchor) {
          const s = localFormToUtcDateAndTime(anchor, day.start_time);
          if (s) start_time = s.time;
        }
        if (day.end_time && anchor) {
          const e = localFormToUtcDateAndTime(anchor, day.end_time);
          if (e) end_time = e.time;
        }
        if (!start_time && day.start_time) {
          start_time = UTCFormat(day.start_time) ?? "";
        }
        if (!end_time && day.end_time) {
          end_time = UTCFormat(day.end_time) ?? "";
        }

        return {
          ...day,
          day: englishDay,
          start_time,
          end_time,
        };
      });
      setData(formattedCalendar);
    };
    formatTimes();
  }, [calendar]);

  const handleSubmitData = (e: any) => {
    e.preventDefault();
    if (!validateCalendar()) {
      return;
    }

    const isValid = calendar.some(
      (day) => day.is_day_off && day.start_time && day.end_time,
    );
    if (!isValid) {
      setCalendarError(
        local_language == "alb"
          ? "Ju lutemi zgjidhni të paktën një orë pune të sallonit."
          : "Please select at least one operational hours of salon.",
      );
      return;
    }

    const isError = calendar.some(
      (day) => day?.error?.start_time != "" || day?.error?.end_time != "",
    );
    if (isError) {
      return;
    }

    const payload: any = {
      edit_id: profile_data?.data?.data?.id,
      opt_days: data,
      // avg_scale: 1
    };

    dispatch(SalonAvailabilityUpdateAction(payload));
  };

  useEffect(() => {
    dispatch(
      SalonAvailabilityDetailAction({
        detail_id: profile_data?.data?.data?.id,
      }),
    );
  }, []);

  useEffect(() => {
    if (salon_detail?.status) {
      if (salon_detail?.data?.data?.days) {
        const updatedCalendar: any = calendar.map((day) => {
          const matchingProfileDay = salon_detail?.data?.data?.days?.find(
            (profileDay: any, is_day_off: any) =>
              albanianToEnglishDaysMap[day.day] == profileDay.day,
          );

          if (matchingProfileDay) {
            let local_start_time =
              matchingProfileDay.start_time != "00:00:00" &&
              matchingProfileDay.start_time;
            let local_end_time =
              matchingProfileDay.start_time != "00:00:00" &&
              matchingProfileDay.end_time;

            const originalStartTime =
              local_start_time && local_start_time.length > 0
                ? local_start_time
                : "";
            const originalEndTime =
              local_end_time && local_end_time.length > 0
                ? local_end_time
                : "";

            const anchor =
              WEEKDAY_UTC_ANCHOR[matchingProfileDay.day as string] || null;
            const startUtcPair =
              anchor && originalStartTime
                ? utcStoredToLocalDateAndTime(
                    anchor,
                    String(originalStartTime),
                  )
                : null;
            const endUtcPair =
              anchor && originalEndTime
                ? utcStoredToLocalDateAndTime(
                    anchor,
                    String(originalEndTime),
                  )
                : null;

            if (startUtcPair && endUtcPair) {
              return {
                ...day,
                is_day_off: matchingProfileDay?.is_day_off ? true : false,
                start_time: startUtcPair.timeDate,
                end_time: endUtcPair.timeDate,
              };
            }

            // Parse start_time
            const targetStartDate = moment().toDate();
            const [startHours, startMinutes, startSeconds] =
              String(originalStartTime).split(":");
            targetStartDate.setHours(Number(startHours));
            targetStartDate.setMinutes(Number(startMinutes));
            targetStartDate.setSeconds(Number(startSeconds));
            const formattedStartDate = targetStartDate.toString();

            // Parse end_time
            const targetEndDate = moment().toDate();
            const [endHours, endMinutes, endSeconds] =
              String(originalEndTime).split(":");
            targetEndDate.setHours(Number(endHours));
            targetEndDate.setMinutes(Number(endMinutes));
            targetEndDate.setSeconds(Number(endSeconds));
            const formattedEndDate = targetEndDate.toString();

            // Check validity of formatted dates
            if (
              formattedStartDate?.length > 0 &&
              formattedStartDate !== "Invalid Date" &&
              formattedEndDate?.length > 0 &&
              formattedEndDate !== "Invalid Date"
            ) {
              const startTime = LocalFormat(formattedStartDate);
              const endTime = LocalFormat(formattedEndDate);
              return {
                ...day,
                is_day_off: matchingProfileDay?.is_day_off ? true : false,
                start_time: formattedStartDate
                  ? moment(startTime).toDate()
                  : "",
                end_time: formattedEndDate ? moment(endTime).toDate() : "",
              };
            }
          }

          return day;
        });
        setCalendar(updatedCalendar);
      }
    }
  }, [salon_detail]);

  // useEffect(() => {
  //     dispatch(BlockServiceReasonAction({}))
  // }, []);

  return (
    <>
      <div className="col-lg-9 addNewService">
        {salon_detail?.loading || block_service_close_reason?.loading ? (
          <Spinner />
        ) : (
          ""
        )}
        <div className="dashboard bg-white">
          <div className="dashboardTop">
            <h2>
              <button
                type="button"
                onClick={() => {
                  sidebarOpen();
                }}
                className="btn mobileMenu p-1 d-lg-none"
              >
                <span className="icon-menu-right"></span>
              </button>{" "}
              <FormattedMessage id="salon_availability_title" />
            </h2>
          </div>
          <div className="dashboarcard">
            <form onSubmit={handleSubmitData}>
              <div className="WOrkDay table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <FormattedMessage id="operational_days_of_salon" />*
                      </th>
                      <th>
                        <FormattedMessage id="operational_hours_of_salon" />*
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {calendar?.length > 0 &&
                      calendar.map((item: any, index: any) => {
                        // item.end_time != "00:00:00" ? item.end_time : null
                        return (
                          <tr key={index}>
                            <td>
                              <div className="form-check ps-0">
                                <input
                                  className="form-check-input"
                                  id={`flexCheckDefault${index}`}
                                  type="checkbox"
                                  checked={item.is_day_off}
                                  onChange={(e: any) => {
                                    handleCheckboxChange(
                                      index,
                                      "start_time",
                                      "end_time",
                                      item.error,
                                    );
                                    setCalendarError("");
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`flexCheckDefault${index}`}
                                >
                                  <FormattedMessage id={albanianToEnglishDaysMap[item.day] || item.day} />
                                </label>
                              </div>
                            </td>
                            <td>
                              <div className="row normalINput">
                                <div className="col-6">
                                  <DatePicker
                                    className="form-control"
                                    // selected={item?.start_time ? (extractTimeFromDate(item?.start_time) == "00:00:00" ? null : item?.start_time) : null}
                                    selected={
                                      item.start_time ? item.start_time : null
                                    }
                                    onChange={(date: any) => {
                                      handleInputFieldChange(
                                        index,
                                        "start_time",
                                        date,
                                      );
                                      setCalendarError("");
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={10}
                                    timeCaption="Time"
                                    // dateFormat="HH:mm"

                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    placeholderText="00:00"
                                  />

                                  <p className="text-danger">
                                    {item.error.start_time}
                                  </p>
                                </div>
                                <div className="col-6">
                                  <DatePicker
                                    // selected={item?.end_time ? (extractTimeFromDate(item?.end_time) == "00:00:00" ? null : item?.end_time) : null}
                                    selected={
                                      item.end_time ? item.end_time : null
                                    }
                                    className="form-control"
                                    onChange={(time: any) => {
                                      handleInputFieldChange(
                                        index,
                                        "end_time",
                                        time,
                                      );
                                      setCalendarError("");
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={10}
                                    timeCaption="Time"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    placeholderText="00:00"
                                  />

                                  <p className="text-danger">
                                    {item.error.end_time}
                                  </p>
                                </div>
                              </div>
                            </td>
                            {index === 0 && (
                              <td>
                                <button
                                  type="button"
                                  className="applyAll"
                                  onClick={handleToClickAll}
                                >
                                  <FormattedMessage id="apply_for_all" />
                                </button>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    {calendarError && (
                      <tr>
                        <td className="text-danger">{calendarError}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Button
                text={(<FormattedMessage id="Save" />) as any}
                type="submit"
                className="btn btn-fill min-180"
                isLoading={salon_availability_update?.loading}
              />
            </form>

            {/*  ********************** Block Service Data ********************** */}

            <BlockService />
          </div>
        </div>
      </div>
    </>
  );
};

export default SalonAvailability;
// import Sidebar from '../../../../components/Layout/Sidebar'

// const SalonAvailability = () => {
//     return (
//         <>
//            <div className='col-lg-9 addNewService'>
//                         <div className='dashboard bg-white'>
//                             <div className='dashboardTop'>
//                                 <h2><button type='button' className='btn mobileMenu p-1 d-lg-none'><span className="icon-menu-right"></span></button> Salon Availability</h2>
//                             </div>
//                             <div className='dashboarcard'>
//                                 <div className='WOrkDay table-responsive p-0'>
//                                     <table className='table'>
//                                         <thead>
//                                             <tr>
//                                                 <th>Operational Days of Salon</th>
//                                                 <th>Operational Hours of Salon</th>
//                                                 <th>&nbsp;</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-check">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
//                                                         <label className="form-check-label" htmlFor="flexCheckDefault">
//                                                             Monday
//                                                         </label>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='d-flex normalINput'>
//                                                         <input type="number" className="form-control" placeholder='00 : 00' />
//                                                         <span className='amStyle'>AM</span>
//                                                         <input type="number" className="form-control ms-3" placeholder='00 : 00' />
//                                                         <span className='amStyle'>PM</span>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <p className='applyAll'>Apply for All</p>
//                                                 </td>
//                                             </tr>
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-check">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault1" />
//                                                         <label className="form-check-label" htmlFor="flexCheckDefault1">
//                                                             Tuesday
//                                                         </label>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='d-flex normalINput'>
//                                                         <input type="number" className="form-control" placeholder='00 : 00' />
//                                                         <span className='amStyle'>AM</span>
//                                                         <input type="number" className="form-control ms-3" placeholder='00 : 00' />
//                                                         <span className='amStyle'>PM</span>
//                                                     </div>
//                                                 </td>
//                                                 <td>&nbsp;</td>
//                                             </tr>
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-check">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault2" />
//                                                         <label className="form-check-label" htmlFor="flexCheckDefault2">
//                                                             Wednesday
//                                                         </label>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='d-flex normalINput'>
//                                                         <input type="number" className="form-control" placeholder='00 : 00' />
//                                                         <span className='amStyle'>AM</span>
//                                                         <input type="number" className="form-control ms-3" placeholder='00 : 00' />
//                                                         <span className='amStyle'>PM</span>
//                                                     </div>
//                                                 </td>
//                                                 <td>&nbsp;</td>
//                                             </tr>
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-check">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault3" />
//                                                         <label className="form-check-label" htmlFor="flexCheckDefault3">
//                                                             Thursday
//                                                         </label>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='d-flex normalINput'>
//                                                         <input type="number" className="form-control" placeholder='00 : 00' />
//                                                         <span className='amStyle'>AM</span>
//                                                         <input type="number" className="form-control ms-3" placeholder='00 : 00' />
//                                                         <span className='amStyle'>PM</span>
//                                                     </div>
//                                                 </td>
//                                                 <td>&nbsp;</td>
//                                             </tr>
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-check">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault4" />
//                                                         <label className="form-check-label" htmlFor="flexCheckDefault4">
//                                                             Friday
//                                                         </label>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='d-flex normalINput'>
//                                                         <input type="number" className="form-control" placeholder='00 : 00' />
//                                                         <span className='amStyle'>AM</span>
//                                                         <input type="number" className="form-control ms-3" placeholder='00 : 00' />
//                                                         <span className='amStyle'>PM</span>
//                                                     </div>
//                                                 </td>
//                                                 <td>&nbsp;</td>
//                                             </tr>
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-check">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault5" />
//                                                         <label className="form-check-label" htmlFor="flexCheckDefault5">
//                                                             Saturday
//                                                         </label>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='d-flex normalINput'>
//                                                         <input type="number" className="form-control" placeholder='00 : 00' />
//                                                         <span className='amStyle'>AM</span>
//                                                         <input type="number" className="form-control ms-3" placeholder='00 : 00' />
//                                                         <span className='amStyle'>PM</span>
//                                                     </div>
//                                                 </td>
//                                                 <td>&nbsp;</td>
//                                             </tr>
//                                             <tr>
//                                                 <td>
//                                                     <div className="form-check">
//                                                         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault6" />
//                                                         <label className="form-check-label" htmlFor="flexCheckDefault6">
//                                                             Sunday
//                                                         </label>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div className='d-flex normalINput'>
//                                                         <input type="number" className="form-control" placeholder='00 : 00' />
//                                                         <span className='amStyle'>AM</span>
//                                                         <input type="number" className="form-control ms-3" placeholder='00 : 00' />
//                                                         <span className='amStyle'>PM</span>
//                                                     </div>
//                                                 </td>
//                                                 <td>&nbsp;</td>
//                                             </tr>
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 <button type="submit" className="btn btn-fill min-180">Save</button>

//                                 <div className='BlockServiceDate mt-5'>
//                                     <h6>Block Service Dates</h6>
//                                     <form>
//                                         <p><b>Select Date Range</b></p>
//                                         <div className='row gy-3 align-items-end'>
//                                             <div className="col-md-3 normalINput">
//                                                 <label className="form-label f-16 fw-500">From</label>
//                                                 <input type="date" className="form-control" />
//                                             </div>
//                                             <div className="col-md-3 normalINput">
//                                                 <label className="form-label f-16 fw-500">To</label>
//                                                 <input type="date" className="form-control" />
//                                             </div>
//                                             <div className="col-md-6 normalINput">
//                                                 <label className='form-label'>Select Type of Unavailability<span>*</span></label>
//                                                 <select className="form-select">
//                                                     <option selected>Select Category</option>
//                                                     <option value="1">One</option>
//                                                     <option value="2">Two</option>
//                                                     <option value="3">Three</option>
//                                                 </select>
//                                             </div>
//                                         </div>
//                                         <p><b>Select Time Range</b></p>
//                                         <div className='row gy-3'>
//                                             <div className="col-md-3 normalINput">
//                                                 <label className="form-label f-16 fw-500">From</label>
//                                                 <input type="date" className="form-control" />
//                                             </div>
//                                             <div className="col-md-3 normalINput">
//                                                 <label className="form-label f-16 fw-500">To</label>
//                                                 <input type="date" className="form-control" />
//                                             </div>
//                                             <div className="col-md-6 normalINput">
//                                                 <label className='form-label'>Select Reason to Close Service<span>*</span></label>
//                                                 <select className="form-select">
//                                                     <option selected>Select Category</option>
//                                                     <option value="1">One</option>
//                                                     <option value="2">Two</option>
//                                                     <option value="3">Three</option>
//                                                 </select>
//                                                 <textarea className='form-select mt-2' placeholder='Enter reason '></textarea>
//                                             </div>
//                                         </div>
//                                         <button type="submit" className="btn btn-fill mt-5 min-180">Submit</button>
//                                     </form>

//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//         </>
//     )
// }

// export default SalonAvailability
